import type { Dispatch, SetStateAction } from 'react';
import { useEffect } from 'react';
import type { FiltersInterface } from '@/types/Miscellaneous';

export function useResetProjectListPage(filters: FiltersInterface, setPage: Dispatch<SetStateAction<number>>) {
  const filtersKey = JSON.stringify(filters);

  useEffect(() => {
    setPage(1);
  }, [filtersKey, setPage]);
}
